import { Component, input, Input, InputSignal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import { ParcelsPreviewComponent } from '../../common/components/parcels/parcels-preview/parcels-preview.component';
import {
  BusStopsPreviewComponent
} from '../sections/list-of-stops-section/components/bus-stops-preview/bus-stops-preview.component';

@Component({
  selector: 'app-agreement-on-terms-rules-bus-stops-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent,
    BusStopsPreviewComponent
  ],
  templateUrl: './agreement-on-terms-rules-bus-stops-preview.component.html'
})
export class AgreementOnTermsRulesBusStopsPreviewComponent {
  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);
}
